<template>
    <Upsell :selectedProduct="selectedProduct" :products="products" />
    <section class="px-4 py-14 pt-8 pb-8 mx-auto max-w-screen-2xl md:py-28 md-max:pb-20 md:pt-8 sm:px-10 lg:px-16"
        id="the-products">
        <!-- Main Heading -->
        <div class="font-bold text-center text-38 text-lifeboost-orange-200 font-ww-medium"
            v-html="mainHeading.split('!')[0] || mainHeading"></div>

        <!-- Sub Heading -->
        <div class="mx-auto mt-10 max-w-screen-lg font-bold text-center lg:px-32 md:mt-24 title-mushroom font-ww-medium text-lifeboost-gray-lighter"
            v-html="subHeading"></div>

        <!-- Discount Text -->
        <div class="mt-12 text-center leading-46 md:mt-16 md:px-10 text-40 font-ww-medium text-lifeboost-gray-lighter"
            v-html="discountText"></div>

        <!-- Product Section -->
        <div
            class="grid grid-cols-12 gap-x-6 gap-y-8 mx-auto mt-10 max-w-screen-xl md:mt-24 lg:gap-x-8 2xl:gap-x-8 md:gap-x-8 lg:mb-12 xl:px-8">
            <!-- Product 1 - Triple Mushroom Boost -->
            <div class="flex flex-col col-span-12 h-full cursor-pointer md:col-span-6" @click="selectProduct(0)">
                <div class="flex flex-col h-full rounded-3xl border" :class="selectedProductIndex === 0 ? '' : 'border border-white'">
                    <div class="px-6 pt-10 h-full lg:px-8 xl:px-10 2xl:px-14"
                        :class="selectedProductIndex === 0 ? 'bg-[#FBF0E5] border-x-2 border-t-2 rounded-t-3xl border-lifeboost-orange-dark' : 'border-gray600 border rounded-t-3xl'">
                        <div class="mb-10 space-y-8">
                            <div
                                class="flex gap-x-4 justify-center items-center text-3xl font-bold text-center us-max:text-27 md:text-2xl lg:text-3xl font-ww-medium text-lifeboost-gray-lighter">


                                <span class="">
                                    <svg v-if="selectedProductIndex === 0" class="w-10 lg:w-10 md:w-8" width="37" height="37" viewBox="0 0 37 37"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="18.5" cy="18.5" r="18.5" fill="#AC4F35" />
                                        <path
                                            d="M28.5625 12.75C28.5625 13.1178 28.4221 13.4858 28.1414 13.7661L16.6414 25.2661C16.3617 25.5482 15.9934 25.6875 15.625 25.6875C15.2566 25.6875 14.8892 25.5471 14.6089 25.2664L8.85887 19.5164C8.57811 19.2367 8.4375 18.8684 8.4375 18.5C8.4375 17.6788 9.10908 17.0625 9.875 17.0625C10.2428 17.0625 10.6108 17.2029 10.8911 17.4836L15.625 22.2195L26.1098 11.7348C26.3883 11.4531 26.7566 11.3125 27.125 11.3125C27.8932 11.3125 28.5625 11.9279 28.5625 12.75Z"
                                            fill="white" />
                                    </svg>
                                </span>

                                <span class="py-2 leading-none">
                                    {{ product1Heading }}
                                </span>
                            </div>
                            <div>
                                <nuxt-img sizes="xs:225px sm:325px md:394px lg:410px xl:435" :src="product1ImgSrc"
                                    :alt="product1ImgAlt" class="px-6 mx-auto md:px-0" width="400" height="310"
                                    loading="lazy" format="webp" />
                            </div>

                            <div class="max-w-md">
                                <div class="text-2xl md:text-xl font-ww-light text-lifeboost-gray-lighter"
                                    v-html="product1Description"></div>
                            </div>

                            <div class="grid gap-y-6 mb-10">
                                <div class="flex gap-x-3 items-start sm:items-start md:items-start xl:items-center md:gap-x-4"
                                    v-for="(gift, index) in product1Gifts" :key="index">

                                    <div>
                                        <nuxt-img class="mt-0.5 md:mt-0 sm-max:w-7" :src="giftIconSrc"
                                            :alt="giftIconAlt" width="28" height="28" format="webp"
                                            loading="lazy"></nuxt-img>
                                    </div>
                                    <div
                                        class="w-full text-22 md:text-xl font-ww-light text-lifeboost-gray-lighter !leading-7 md:!leading-6">
                                        <div v-html="gift.gift"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="px-6 py-8 rounded-b-3xl lg:px-12 2xl:px-14 md:py-10 lg:py-10 xl:py-14"
                        :class="selectedProductIndex === 0 ? 'bg-lifeboost-orange-100' : 'bg-gray600'">
                        <div class="flex justify-center items-center md:justify-start">
                            <div class="flex items-center">
                                <div class="relative pr-2 leading-none line-through text-32"
                                    :class="selectedProductIndex === 0 ? 'text-white' : 'text-lifeboost-gray-lighter'">
                                    {{ product1OriginalPrice }}
                                </div>
                                <div class="font-bold leading-none text-32 text-lifeboost-gray-lighter font-ww-medium"
                                    :class="selectedProductIndex === 0 ? 'text-white' : 'text-lifeboost-gray-lighter'">
                                    {{ product1DiscountedPrice }}
                                </div>
                            </div>

                            <div
                                class="flex items-center px-5 py-1.5 mt-0.5 ml-4 text-lg text-white rounded-full md:text-base bg-lifeboost-blue-300 font-ww-medium">
                                {{ product1SaveText }}
                            </div>
                        </div>

                        <div>
                            <div class="flex justify-center mt-6 md:mt-8">
                                <button @click="addToCart(products[0])"
                                    class="flex items-center bnt-icon-small md-max:w-full"
                                    :class="selectedProductIndex === 0 ? '!bg-white !text-lifeboost-orange-dark' : ''">
                                    <span class="flex items-center">{{ product1ButtonText }}</span>
                                    <svg class="relative top-0.5 ml-4 w-6 sm:w-auto" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="23px"
                                        viewBox="0 0 38 31">
                                        <path fill-rule="evenodd"
                                            :fill="selectedProductIndex === 0 ? '#E48414' : 'rgb(255,255,255)'"
                                            d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z">
                                        </path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <nuxt-img :src="productIconsSrc" :alt="productIconsAlt" class="pt-3 mx-auto" width="487" height="66"
                    loading="lazy" format="webp" />
            </div>

            <!-- Product 2 - Turbo Mushroom Boost -->
            <div class="flex flex-col col-span-12 h-full cursor-pointer md:col-span-6" @click="selectProduct(1)">
                <div class="flex flex-col rounded-3xl" :class="selectedProductIndex === 1 ? '' : 'border border-white'">
                    <div class="px-6 pt-10 h-full lg:px-8 xl:px-10 2xl:px-14"
                        :class="selectedProductIndex === 1 ? 'bg-[#FBF0E5] border-x-2 border-t-2 rounded-t-3xl border-lifeboost-orange-dark' : 'border-gray600 border rounded-t-3xl'">
                        <div class="mb-10 space-y-8">
                            <div
                                class="flex gap-x-4 justify-center items-center text-3xl font-bold text-center us-max:text-27 md:text-2xl lg:text-3xl font-ww-medium text-lifeboost-gray-lighter">


                                <span class="">
                                    <svg v-if="selectedProductIndex === 1" class="w-10 lg:w-10 md:w-8" width="37" height="37" viewBox="0 0 37 37"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="18.5" cy="18.5" r="18.5" fill="#AC4F35" />
                                        <path
                                            d="M28.5625 12.75C28.5625 13.1178 28.4221 13.4858 28.1414 13.7661L16.6414 25.2661C16.3617 25.5482 15.9934 25.6875 15.625 25.6875C15.2566 25.6875 14.8892 25.5471 14.6089 25.2664L8.85887 19.5164C8.57811 19.2367 8.4375 18.8684 8.4375 18.5C8.4375 17.6788 9.10908 17.0625 9.875 17.0625C10.2428 17.0625 10.6108 17.2029 10.8911 17.4836L15.625 22.2195L26.1098 11.7348C26.3883 11.4531 26.7566 11.3125 27.125 11.3125C27.8932 11.3125 28.5625 11.9279 28.5625 12.75Z"
                                            fill="white" />
                                    </svg>
                                </span>

                                <span class="py-2 leading-none">
                                    {{ product2Heading }}
                                </span>
                            </div>
                            <div>
                                <nuxt-img :src="product2ImgSrc" :alt="product2ImgAlt" class="px-6 mx-auto md:px-0"
                                    width="400" height="310" loading="lazy" format="webp" />
                            </div>

                            <div class="max-w-md">
                                <div class="text-2xl md:text-xl font-ww-light text-lifeboost-gray-lighter"
                                    v-html="product2Description"></div>
                            </div>

                            <div class="grid gap-y-6 mb-10">
                                <div class="flex gap-x-3 items-start sm:items-start md:items-start xl:items-center md:gap-x-4"
                                    v-for="(gift, index) in product2Gifts" :key="index">
                                    <div>
                                        <nuxt-img class="mt-0.5 md:mt-0 sm-max:w-7" :src="giftIconSrc"
                                            :alt="giftIconAlt" width="28" height="28" format="webp"
                                            loading="lazy"></nuxt-img>
                                    </div>
                                    <div
                                        class="w-full text-22 md:text-xl font-ww-light text-lifeboost-gray-lighter !leading-7 md:!leading-6">
                                        <div v-html="gift.gift"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="px-6 py-8 rounded-b-3xl md:py-10 lg:py-10 xl:py-14 lg:px-12 2xl:px-14"
                        :class="selectedProductIndex === 1 ? 'bg-lifeboost-orange-100' : 'bg-gray600'">
                        <div class="flex justify-center items-center md:justify-start">
                            <div class="flex items-center">
                                <div class="relative pr-2 leading-none line-through text-32"
                                    :class="selectedProductIndex === 1 ? 'text-white' : 'text-lifeboost-gray-lighter'">
                                    {{ product2OriginalPrice }}
                                </div>
                                <div class="font-bold leading-none text-32 font-ww-medium"
                                    :class="selectedProductIndex === 1 ? 'text-white' : 'text-lifeboost-gray-lighter'">
                                    {{ product2DiscountedPrice }}
                                </div>
                            </div>

                            <div
                                class="flex items-center px-5 py-1.5 mt-0.5 ml-4 text-lg text-white rounded-full md:text-base bg-lifeboost-blue-300 font-ww-medium">
                                {{ product2SaveText }}
                            </div>
                        </div>

                        <div>
                            <div class="flex justify-center mt-6 md:mt-8">
                                <button @click="addToCart(products[1])"
                                    class="flex items-center bnt-icon-small md-max:w-full"
                                    :class="selectedProductIndex === 1 ? '!bg-white !text-lifeboost-orange-dark' : ''">
                                    <span class="flex items-center">{{ product2ButtonText }}</span>
                                    <svg class="relative top-0.5 ml-4 w-6 sm:w-auto" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="23px"
                                        viewBox="0 0 38 31">
                                        <path fill-rule="evenodd" fill="#E48414"
                                            d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z">
                                        </path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <nuxt-img :src="productIconsSrc" :alt="productIconsAlt" class="pt-3 mx-auto" width="487" height="66"
                    loading="lazy" format="webp" />
            </div>
        </div>
    </section>
</template>

<script setup>
import Upsell from "./Upsell"; // Better Readability 
const props = defineProps({
    // Main Heading, Sub Heading, and Discount Text
    mainHeading: {
        type: String,
        default: "END OF SUMMER SALE"
    },
    subHeading: {
        type: String,
        default: "Get All-Day Energy and Focus With the Power of Healthy, Low-Acid Coffee Upgraded with High-Potency Real Mushrooms"
    },
    discountText: {
        type: String,
        default: "Get 68% Off Cognition Mushroom Coffee + FREE GIFTS–Ends Soon!"
    },
    // Product 1 Props
    product1Heading: {
        type: String,
        default: "Triple Mushroom Boost"
    },
    product1ImgSrc: {
        type: String,
        default: "/assets/images/mushroom-3-new.png"
    },
    product1ImgAlt: {
        type: String,
        default: "product 3"
    },
    product1Description: {
        type: String,
        default: "Includes three 12-ounce bags of Cognition Mushroom Coffee and these free gifts:"
    },
    product1Gifts: {
        type: Array,
        default: () => [
            "Free shipping <strong class='font-ww-medium'>($10 value)</strong>",
            "Free Toxin Guide <strong class='font-ww-medium'>($12 value)</strong>",
            "Free Healthy Coffee Recipe Book <strong class='font-ww-medium'>($12 value)</strong>"
        ]
    },
    giftIconSrc: {
        type: String,
        default: "/assets/images/check122.png"
    },
    giftIconAlt: {
        type: String,
        default: "icon check"
    },
    product1OriginalPrice: {
        type: String,
        default: "$138.85"
    },
    product1DiscountedPrice: {
        type: String,
        default: "$52"
    },
    product1SaveText: {
        type: String,
        default: "SAVE 68%"
    },
    product1ButtonText: {
        type: String,
        default: "Add to Cart"
    },
    productIconsSrc: {
        type: String,
        default: "/assets/images/icons.png"
    },
    productIconsAlt: {
        type: String,
        default: "icons"
    },
    // Product 2 Props
    product2Heading: {
        type: String,
        default: "Turbo Mushroom Boost"
    },
    product2ImgSrc: {
        type: String,
        default: "/assets/images/mushroom-6-new.png"
    },
    product2ImgAlt: {
        type: String,
        default: "product 6"
    },
    product2Description: {
        type: String,
        default: "Includes three 12-ounce bags of Cognition Mushroom Coffee and these free gifts:"
    },
    product2Gifts: {
        type: Array,
        default: () => [
            "Free shipping <strong class='font-ww-medium'>($10 value)</strong>",
            "Free Toxin Guide <strong class='font-ww-medium'>($12 value)</strong>",
            "Free Healthy Coffee Recipe Book <strong class='font-ww-medium'>($12 value)</strong>",
            "Free coffee spoon <strong class='font-ww-medium'>($15 value)</strong>",
            "Free coffee with Bonus Perks <strong class='font-ww-medium'>($20 value)</strong>"
        ]
    },
    product2OriginalPrice: {
        type: String,
        default: "$278.70"
    },
    product2DiscountedPrice: {
        type: String,
        default: "$89"
    },
    product2SaveText: {
        type: String,
        default: "SAVE 68%"
    },
    product2ButtonText: {
        type: String,
        default: "Add to Cart"
    }
});

defineBuilderComponent({
    friendlyName: "Options Products With Upsell",
    inputs: [
        // Main Heading, Sub Heading, and Discount Text inputs
        {
            name: "mainHeading",
            type: "string",
            friendlyName: "Main Heading",
            defaultValue: "END OF SUMMER SALE"
        },
        {
            name: "subHeading",
            type: "richText",
            friendlyName: "Sub Heading",
            defaultValue: "Get All-Day Energy and Focus With the Power of Healthy, Low-Acid Coffee Upgraded with High-Potency Real Mushrooms"
        },
        {
            name: "discountText",
            type: "string",
            friendlyName: "Discount Text",
            defaultValue: "Get 68% Off Cognition Mushroom Coffee + FREE GIFTS–Ends Soon!"
        },
        // Product 1 Inputs
        {
            name: "product1Heading",
            type: "string",
            friendlyName: "Product 1 Heading",
            defaultValue: "Triple Mushroom Boost"
        },
        {
            name: "product1ImgSrc",
            type: "file",
            friendlyName: "Product 1 Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/mushroom-3-new.png"
        },
        {
            name: "product1ImgAlt",
            type: "string",
            friendlyName: "Product 1 Image Alt Text",
            defaultValue: "product 3"
        },
        {
            name: "product1Description",
            type: "richText",
            friendlyName: "Product 1 Description",
            defaultValue: "Includes three 12-ounce bags of Cognition Mushroom Coffee and these free gifts:"
        },
        {
            name: "product1Gifts",
            type: "list",
            friendlyName: "Product 1 Gifts",
            subFields: [
                {
                    name: "gift",
                    type: "richText",
                    friendlyName: "Gift Description",
                    defaultValue: ""
                }
            ],
            defaultValue: [
                { gift: "Free shipping <strong class='font-ww-medium'>($10 value)</strong>" },
                { gift: "Free Toxin Guide <strong class='font-ww-medium'>($12 value)</strong>" },
                { gift: "Free Healthy Coffee Recipe Book <strong class='font-ww-medium'>($12 value)</strong>" }
            ]
        },
        {
            name: "giftIconSrc",
            type: "file",
            friendlyName: "Gift Icon Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/check122.png"
        },
        {
            name: "giftIconAlt",
            type: "string",
            friendlyName: "Gift Icon Alt Text",
            defaultValue: "icon check"
        },
        {
            name: "product1OriginalPrice",
            type: "string",
            friendlyName: "Product 1 Original Price",
            defaultValue: "$138.85"
        },
        {
            name: "product1DiscountedPrice",
            type: "string",
            friendlyName: "Product 1 Discounted Price",
            defaultValue: "$52"
        },
        {
            name: "product1SaveText",
            type: "string",
            friendlyName: "Product 1 Save Text",
            defaultValue: "SAVE 68%"
        },
        {
            name: "product1ButtonText",
            type: "string",
            friendlyName: "Product 1 Button Text",
            defaultValue: "Add to Cart"
        },
        {
            name: "productIconsSrc",
            type: "file",
            friendlyName: "Product Icons Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/icons.png"
        },
        {
            name: "productIconsAlt",
            type: "string",
            friendlyName: "Product Icons Alt Text",
            defaultValue: "icons"
        },
        // Product 2 Inputs
        {
            name: "product2Heading",
            type: "string",
            friendlyName: "Product 2 Heading",
            defaultValue: "Turbo Mushroom Boost"
        },
        {
            name: "product2ImgSrc",
            type: "file",
            friendlyName: "Product 2 Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/mushroom-6-new.png"
        },
        {
            name: "product2ImgAlt",
            type: "string",
            friendlyName: "Product 2 Image Alt Text",
            defaultValue: "product 6"
        },
        {
            name: "product2Description",
            type: "richText",
            friendlyName: "Product 2 Description",
            defaultValue: "Includes three 12-ounce bags of Cognition Mushroom Coffee and these free gifts:"
        },
        {
            name: "product2Gifts",
            type: "list",
            friendlyName: "Product 2 Gifts",
            subFields: [
                {
                    name: "gift",
                    type: "richText",
                    friendlyName: "Gift Description",
                    defaultValue: ""
                }
            ],
            defaultValue: [
                { gift: "Free shipping <strong class='font-ww-medium'>($10 value)</strong>" },
                { gift: "Free Toxin Guide <strong class='font-ww-medium'>($12 value)</strong>" },
                { gift: "Free Healthy Coffee Recipe Book <strong class='font-ww-medium'>($12 value)</strong>" },
                { gift: "Free coffee spoon <strong class='font-ww-medium'>($15 value)</strong>" },
                { gift: "Free coffee with Bonus Perks <strong class='font-ww-medium'>($20 value)</strong>" }
            ]
        },
        {
            name: "product2OriginalPrice",
            type: "string",
            friendlyName: "Product 2 Original Price",
            defaultValue: "$278.70"
        },
        {
            name: "product2DiscountedPrice",
            type: "string",
            friendlyName: "Product 2 Discounted Price",
            defaultValue: "$89"
        },
        {
            name: "product2SaveText",
            type: "string",
            friendlyName: "Product 2 Save Text",
            defaultValue: "SAVE 68%"
        },
        {
            name: "product2ButtonText",
            type: "string",
            friendlyName: "Product 2 Button Text",
            defaultValue: "Add to Cart"
        }
    ]
});



const cart = useCart();
const upsellModal = useState('upsellModal')
const products = [
    { id: '43362772680764', qty: 3, price: 54, title: 'Triple Mushroom Boost', image: props.product1ImgSrc, compareAtPrice: 138.85 },
    { id: '43362772680764', qty: 6, price: 99, title: 'Turbo Mushroom Boost', image: props.product2ImgSrc, compareAtPrice: 278.70 },
    { id: '32453656150076', qty: 1, price: 74.85, title: 'Signature Bundle' }
];
const selectedProduct = ref(products[0]);
const selectedProductIndex = ref(1);
function addToCart(product) {
    cart.add(product)
    selectedProduct.value = product;
    upsellModal.value = true;
}

function selectProduct(index) {
    selectedProductIndex.value = index;
}

</script>
